import { Drawer } from 'ui-components/components/drawer/drawer';
import { DrawerHeader } from 'ui-components/components/drawer/drawer-header';

import { messages } from './messages';
import styles from './styles.module.less';
import { StepDetective } from '../step-detective/step-detective';
import { useStepDetectiveContext } from '../step-detective/step-detective-context';

/**
 *
 * @param {object} props
 * @param {React.ReactNode} props.header
 * @param {(stepId: string) => () => void} props.onCancel
 * @returns {JSX.Element}
 */
export const ImportDrawer = ({ onCancel, header }) => {
  const { steps, activeStep, activeStepIndex } = useStepDetectiveContext();

  return (
    <Drawer className={styles['import-drawer']} onCancel={onCancel(activeStep.id)} onClose={onCancel(activeStep.id)}>
      <DrawerHeader closeButtonAriaLabel={messages.closeDrawerButtonAriaLabel} title={header} />
      <div className={styles['drawer-body']}>
        <div className={styles['drawer-body-inner']}>
          <div className={styles['step-detective']}>
            <StepDetective activeStepIndex={activeStepIndex} steps={steps} />
          </div>
          <div className={styles.step}>{activeStep.body}</div>
        </div>
      </div>
      <div className={styles['drawer-footer']}>{activeStep.footer}</div>
    </Drawer>
  );
};
